import FormField from "./FormField";
import PropTypes from "prop-types";
import React, {useEffect} from "react";
import YesNoField from "./YesNoField";
import {useFormikContext} from "formik";

const phoneTypeOptions = ["Cell", "Home", "Work"];

const PhoneField = ({entity, label, name, required}) => {
  const {values, setValues} = useFormikContext();
  const phoneType = values[entity] ? values[entity][`${name}_type`] : "";
  const prefix = `${entity}.${name}`;
  const optInName = `${prefix}_opt_in`;

  // clear opt-in selection when phone type changes
  useEffect(() => {
    if (phoneType !== "Cell") {
      const entityValues = values[entity] || {};
      setValues({...values, [entity]: {...entityValues, [`${name}_opt_in`]: ""}});
    }
  }, [phoneType]);

  return (
    <React.Fragment>
      <div className="row">
        <FormField label={label} type="text" name={`${prefix}_number`} colWidth={6} required={required} />
        <FormField label="Type" type="select" name={`${prefix}_type`} options={phoneTypeOptions} colWidth={4} required={required} />
      </div>

      {phoneType === "Cell" && (
        <div className="row">
          <YesNoField
            label="SMS Opt In"
            name={optInName}
            help={() => (<p>
              By selecting "Yes", you agree to receive SMS text messages from the schools to which you apply.
              Message and data rates may apply.
            </p>)}
            required={required}
          />
        </div>
      )}
    </React.Fragment>
  );
}

PhoneField.propTypes = {
  label: PropTypes.string.isRequired,
  entity: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool
};

PhoneField.defaultProps = {
  required: false
};

export default PhoneField;
